import { getParam, setStorage, getStorage } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY, IS_TOUFANG_STORE_KEY} from './constant'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = 'https://static.novelfreedom.com/paynovel/video/';
// https://static.novelfreedom.com/paynovel/h5-pay-asia/


// 获取版本号
export const getVersion = () => {
    return '1.0.9'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    return APP_CONFIG[getAppID()]?.fbPixleId || APP_CONFIG['default'].fbPixleId
}


export const getPathLang = () => {
    const app = getAppID();
    return APP_CONFIG[app]?.lang || APP_CONFIG['default'].lang || 'en'
}

export const getAppID = ()=>{
    if(process.env.NODE_ENV === 'dev'){
        return 'melonflix'
    }
    if(process.env.VUE_APP_ENV === 'test'){
        return 'melonflix'
    }
    let host = location.host && location.host.split('.'); 
    
    return host.length < 2 ? "" : host[host.length -2];
}


export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}

export const setCookieAdId = () => {
    const adId = getParam('af_ad_id');
    if (adId) {
        Cookies.set(AD_ID_COOKIES_KEY, adId, { expires: 365, path: '/' });
    }
}

export const APP_CONFIG = {
    orangenovel: {
        fbPixleId: '4068577130050988',
        lang: 'en',
        name: 'OrangeNovel',
        company: 'OrangeNovel.com',
        email: 'ops@novellettes.com',
    },
    melonflix: {
        fbPixleId: '4068577130050988',
        lang: 'en',
        name: 'DramaZ',
        company: 'melonflix.com',
        email: 'ops@novellettes.com',
    },
    default: {
        fbPixleId: '1081737203961773',
        moneySymbol: '$',
        company: 'melonflix.com',
        email: 'ops@novellettes.com',
        lang: 'en'
    }
}


export const getAppInfo = () => {
    const appId = getAppID()
    const obj = {
        name: APP_CONFIG[appId]?.name || APP_CONFIG['default'].name,
        company: APP_CONFIG[appId]?.company || APP_CONFIG['default'].company,
        fbPixleId: APP_CONFIG[appId]?.fbPixleId || APP_CONFIG['default'].fbPixleId,
        email: APP_CONFIG[appId]?.email || APP_CONFIG['default'].email,
    }
    return obj
}

export const setToufang = () => {
    const clid = getParam('read')
    const toufangKey = getStorage(IS_TOUFANG_STORE_KEY)
    if(clid && !toufangKey){
        setStorage(IS_TOUFANG_STORE_KEY, 1)
    }
}


export const isToufang = () => {
    return getStorage(IS_TOUFANG_STORE_KEY) ? 1 : 0
}